{
  "about.blocks": "ڕاژە سەرپەرشتیکراو",
  "about.contact": "پەیوەندی کردن:",
  "about.disclaimer": "ماستودۆن بە خۆڕایە، پرۆگرامێکی سەرچاوە کراوەیە، وە نیشانە بازرگانیەکەی ماستودۆن (gGmbH)ە",
  "about.domain_blocks.no_reason_available": "هۆکار بەردەست نیە",
  "about.domain_blocks.preamble": "ماستۆدۆن بە گشتی ڕێگەت پێدەدات بە پیشاندانی ناوەڕۆکەکان و کارلێک کردن لەگەڵ بەکارهێنەران لە هەر ڕاژەیەکی تر بە گشتی. ئەمانە ئەو بەدەرکردنانەن کە کراون لەسەر ئەم ڕاژە تایبەتە.",
  "about.domain_blocks.silenced.explanation": "بە گشتی ناتوانی زانیاریە تایبەتەکان و ناوەڕۆکی ئەم ڕاژەیە ببینی، مەگەر بە ڕوونی بەدوایدا بگەڕێیت یان هەڵیبژێریت بۆ شوێنکەوتنی.",
  "about.domain_blocks.silenced.title": "سنووردار",
  "about.domain_blocks.suspended.explanation": "هیچ داتایەک لەم سێرڤەرەوە پرۆسێس ناکرێت، هەڵناگیرێت یان ئاڵوگۆڕ ناکرێت، ئەمەش وا دەکات هیچ کارلێکێک یان پەیوەندییەک لەگەڵ بەکارهێنەران لەم سێرڤەرەوە مەحاڵ بێت.",
  "about.domain_blocks.suspended.title": "هەڵپەسێردراوە",
  "about.not_available": "ئەم زانیاریانە لەسەر ئەم سێرڤەرە بەردەست نەکراون.",
  "about.powered_by": "سۆشیال میدیای لامەرکەزی کە لەلایەن {mastodon} ەوە بەهێز دەکرێت",
  "about.rules": "یاساکانی سێرڤەر",
  "account.add_or_remove_from_list": "زیادکردن یان سڕینەوە لە پێرستەکان",
  "account.badges.bot": "بوت",
  "account.badges.group": "گرووپ",
  "account.block": "بلۆکی @{name}",
  "account.block_domain": "بلۆکی هەموو شتێک لە {domain}",
  "account.block_short": "بلۆک",
  "account.blocked": "بلۆککرا",
  "account.cancel_follow_request": "داواکاری فۆڵۆو بکشێنەوە",
  "account.copy": "ڕوونووسی بەستەر بۆ توت",
  "account.direct": "بە شێوەیەکی تایبەت باسی @{name} بکە",
  "account.disable_notifications": "ئاگانامە مەنێرە بۆم کاتێک @{name} پۆست دەکرێت",
  "account.edit_profile": "دەستکاری پرۆفایل",
  "account.enable_notifications": "ئاگادارم بکەوە کاتێک @{name} بابەتەکان",
  "account.endorse": "ناساندن لە پرۆفایل",
  "account.follow": "بەدواداچوون",
  "account.follow_back": "فۆڵۆو بکەنەوە",
  "account.followers": "شوێنکەوتووان",
  "account.followers.empty": "کەسێک شوێن ئەم بەکارهێنەرە نەکەوتووە",
  "account.following": "بەدوادا",
  "account.follows.empty": "ئەم بەکارهێنەرە تا ئێستا شوێن کەس نەکەوتووە.",
  "account.go_to_profile": "بڕۆ بۆ پڕۆفایلی",
  "account.hide_reblogs": "داشاردنی بووستەکان لە @{name}",
  "account.in_memoriam": "لە یادەوەریدا.",
  "account.joined_short": "بەشداری کردووە",
  "account.languages": "گۆڕینی زمانە بەشداربووەکان",
  "account.link_verified_on": "خاوەنداریەتی ئەم لینکە لە {date} چێک کراوە",
  "account.locked_info": "تایبەتمەندی ئەم هەژمارەیە ڕیکخراوە بۆ قوفڵدراوە. خاوەنەکە بە دەستی پێداچوونەوە دەکات کە کێ دەتوانێت شوێنیان بکەوێت.",
  "account.media": "میدیا",
  "account.mention": "ئاماژە @{name}",
  "account.moved_to": "{name} ئاماژەی بەوە کردووە کە ئەکاونتە نوێیەکەیان ئێستا:",
  "account.mute": "بێدەنگکردن @{name}",
  "account.mute_notifications_short": "پاڵ بە ئاگادارکردنەوەکانەوە بنێ",
  "account.mute_short": "بێدەنگ",
  "account.muted": "بێ دەنگ",
  "account.no_bio": "هیچ وەسفێک نەخراوەتەڕوو.",
  "account.open_original_page": "لاپەڕەی ئەسڵی بکەرەوە",
  "account.posts": "نووسراوەکان",
  "account.report": "گوزارشت @{name}",
  "account.requested_follow": "{name} داوای کردووە شوێنت بکەوێت",
  "account.share": "پرۆفایلی @{name} هاوبەش بکە",
  "account.show_reblogs": "پیشاندانی بەرزکردنەوەکان لە @{name}",
  "account.unblock": "@{name} لاببە",
  "account.unblock_domain": "کردنەوەی دۆمەینی {domain}",
  "account.unblock_short": "لابردنی بەربەست",
  "account.unendorse": "تایبەتمەندی لەسەر پرۆفایلەکە نیە",
  "account.unfollow": "بەدوادانەچو",
  "account.unmute": "بێدەنگکردنی @{name}",
  "account.unmute_notifications_short": "ئاگادارکردنەوەکان بێدەنگ بکەرەوە",
  "account.unmute_short": "بێدەنگی مەکە",
  "account_note.placeholder": "کرتەبکە بۆ زیادکردنی تێبینی",
  "admin.dashboard.daily_retention": "ڕێژەی مانەوەی بەکارهێنەر بەپێی ڕۆژ دوای ناو تۆمارکردن",
  "admin.dashboard.monthly_retention": "ڕێژەی مانەوەی بەکارهێنەر بەپێی مانگ دوای ناو تۆمارکردن",
  "admin.dashboard.retention.average": "ڕێژە",
  "admin.dashboard.retention.cohort": "چوونەژوورەوەی مانگانە",
  "admin.dashboard.retention.cohort_size": "ئەندامی نوێ",
  "admin.impact_report.instance_accounts": "پڕۆفایلی هەژمارەکان ئەمە دەسڕێتەوە",
  "admin.impact_report.instance_followers": "فۆڵۆوەرەکان بەکارهێنەران لەدەست دەدەن",
  "admin.impact_report.instance_follows": "فۆڵۆوەرەکان ئەمبەکارهێنەرە لەدەست دەدەن",
  "admin.impact_report.title": "پوختەی کاریگەرییەکان",
  "alert.rate_limited.message": "تکایە هەوڵبدەرەوە دوای {retry_time, time, medium}.",
  "alert.rate_limited.title": "ڕێژەی سنووردار",
  "alert.unexpected.message": "هەڵەیەکی چاوەڕوان نەکراو ڕوویدا.",
  "alert.unexpected.title": "تەححح!",
  "announcement.announcement": "بانگەواز",
  "attachments_list.unprocessed": "(unprocessed)",
  "audio.hide": "شاردنەوەی دەنگ",
  "boost_modal.combo": "دەتوانیت دەست بنێی بە سەر {combo} بۆ بازدان لە جاری داهاتوو",
  "bundle_column_error.copy_stacktrace": "ڕاپۆرتی هەڵەی کۆپی بکە",
  "bundle_column_error.error.body": "لاپەڕەی داواکراو نەتوانرا ڕەندەر بکرێت. دەکرێت بەهۆی هەڵەیەکی کۆدەکەمانەوە بێت، یان کێشەی گونجانی وێبگەڕ.",
  "bundle_column_error.error.title": "ئای نا!",
  "bundle_column_error.network.body": "لە کاتی هەوڵدان بۆ بارکردنی ئەم لاپەڕەیە هەڵەیەک ڕوویدا. ئەمەش دەتوانێت بەهۆی کێشەیەکی کاتی هێڵی ئینتەرنێتەکەت یان ئەم سێرڤەرە بێت.",
  "bundle_column_error.network.title": "هەڵەی تۆڕ",
  "bundle_column_error.retry": "دووبارە هەوڵبدە",
  "bundle_column_error.return": "بگەڕێرەوە ماڵەوە",
  "bundle_column_error.routing.body": "پەیجی داواکراو ناتوانرێت بدۆزرێتەوە. ئایا دڵنیای کە URL ی ناو ناونیشانەکان ڕاستە?",
  "bundle_column_error.routing.title": "٤٠٤",
  "bundle_modal_error.close": "داخستن",
  "bundle_modal_error.retry": "دووبارە تاقی بکەوە",
  "closed_registrations.other_server_instructions": "بەو پێیەی ماستۆدۆن لامەرکەزییە، دەتوانیت ئەکاونتێک لەسەر سێرڤەرێکی تر دروست بکەیت و هێشتا کارلێک لەگەڵ ئەم سێرڤەرەدا بکەیت.",
  "closed_registrations_modal.description": "دروستکردنی ئەکاونت لەسەر {domain} لە ئێستادا ناتوانرێت، بەڵام تکایە ئەوەت لەبەرچاو بێت کە پێویستت بە ئەکاونتێک نییە بە تایبەتی لەسەر {domain} بۆ بەکارهێنانی ماستۆدۆن.",
  "closed_registrations_modal.find_another_server": "سێرڤەرێکی تر بدۆزەرەوە",
  "closed_registrations_modal.preamble": "ماستۆدۆن لامەرکەزییە، بۆیە گرنگ نییە لە کوێ ئەکاونتەکەت دروست بکەیت، دەتوانیت فۆڵۆوی هەر کەسێک بکەیت و کارلێک لەگەڵیدا بکەیت لەسەر ئەم سێرڤەرە. تەنانەت دەتوانیت خۆت میوانداری بکەیت!",
  "closed_registrations_modal.title": "ناو تۆمارکردن لە ماستۆدۆن",
  "column.about": "دەربارە",
  "column.blocks": "بەکارهێنەرە بلۆککراوەکان",
  "column.bookmarks": "نیشانەکان",
  "column.community": "هێڵی کاتی ناوخۆیی",
  "column.direct": "ئاماژەی تایبەت",
  "column.directory": "گەڕان لە پرۆفایلەکان",
  "column.domain_blocks": "دۆمەینە داخراوەکان",
  "column.favourites": "دڵخوازەکان",
  "column.firehose": "فیدی ڕاستەوخۆ",
  "column.follow_requests": "بەدواداچوی داواکاریەکان بکە",
  "column.home": "سەرەتا",
  "column.lists": "پێرست",
  "column.mutes": "بێدەنگکردنی بەکارهێنەران",
  "column.notifications": "ئاگادارییەکان",
  "column.pins": "تووتسی چەسپاو",
  "column.public": "نووسراوەکانی هەمووشوێنێک",
  "column_back_button.label": "دواوە",
  "column_header.hide_settings": "شاردنەوەی ڕێکخستنەکان",
  "column_header.moveLeft_settings": "ستوون بگوێزەرەوە بۆ لای چەپ",
  "column_header.moveRight_settings": "جوولاندنی ئەستوون بۆ لای ڕاست",
  "column_header.pin": "سنجاق",
  "column_header.show_settings": "نیشاندانی رێکخستنەکان",
  "column_header.unpin": "سنجاق نەکردن",
  "community.column_settings.local_only": "تەنها خۆماڵی",
  "community.column_settings.media_only": "تەنها میدیا",
  "community.column_settings.remote_only": "تەنها بۆ دوور",
  "compose.language.change": "گۆڕینی زمان",
  "compose.language.search": "گەڕان بە زمانەکان...",
  "compose.published.body": "پۆست بڵاوکراوەتەوە.",
  "compose.published.open": "بیکەوە",
  "compose.saved.body": "پۆستەکە سەیڤ کراوە.",
  "compose_form.direct_message_warning_learn_more": "زیاتر فێربه",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any dangerous information over Mastodon.",
  "compose_form.hashtag_warning": "ئەم بڵاوکراوەیە لە ژێر هیچ هاشتاگێکدا دا نانرێت وەک ئەوەیە، کە گشتی نەبێت. تەنها بڵاوکراوە گشتیەکان دەتوانرێ بە هاشتاگ گەڕانی بۆ بکرێت.",
  "compose_form.lock_disclaimer": "هەژمێرەکەی لە حاڵەتی {locked}. هەر کەسێک دەتوانێت شوێنت بکەوێت بۆ پیشاندانی بابەتەکانی تەنها دوایخۆی.",
  "compose_form.lock_disclaimer.lock": "قفڵ دراوە",
  "compose_form.placeholder": "چی لە مێشکتدایە?",
  "compose_form.poll.duration": "ماوەی ڕاپرسی",
  "compose_form.poll.multiple": "فرە هەڵبژاردە",
  "compose_form.poll.option_placeholder": "بژاردەی {number}",
  "compose_form.poll.switch_to_multiple": "ڕاپرسی بگۆڕە بۆ ڕێگەدان بە چەند هەڵبژاردنێک",
  "compose_form.poll.switch_to_single": "گۆڕینی ڕاپرسی بۆ ڕێگەدان بە تاکە هەڵبژاردنێک",
  "compose_form.poll.type": "ستایڵ",
  "compose_form.publish": "پۆست",
  "compose_form.reply": "وەڵام",
  "compose_form.save_changes": "نوێکردنەوە",
  "compose_form.spoiler.marked": "دەق لە پشت ئاگاداریدا شاراوەتەوە",
  "compose_form.spoiler.unmarked": "دەق شاراوە نییە",
  "compose_form.spoiler_placeholder": "ئاگادارکردنەوەی ناوەڕۆک (ئیختیاری)",
  "confirmation_modal.cancel": "هەڵوەشاندنەوه",
  "confirmations.block.confirm": "بلۆک",
  "confirmations.delete.confirm": "سڕینەوە",
  "confirmations.delete.message": "ئایا دڵنیایت لەوەی دەتەوێت ئەم توتە بسڕیتەوە?",
  "confirmations.delete_list.confirm": "سڕینەوە",
  "confirmations.delete_list.message": "ئایا دڵنیایت لەوەی دەتەوێت بە هەمیشەیی ئەم لیستە بسڕیتەوە?",
  "confirmations.discard_edit_media.confirm": "ڕەتکردنەوە",
  "confirmations.discard_edit_media.message": "گۆڕانکاریت لە وەسف یان پێشبینی میدیادا هەڵنەگیراوە، بەهەر حاڵ فڕێیان بدە؟",
  "confirmations.logout.confirm": "چوونە دەرەوە",
  "confirmations.logout.message": "ئایا دڵنیایت لەوەی دەتەوێت بچیتە دەرەوە?",
  "confirmations.mute.confirm": "بێدەنگ",
  "confirmations.redraft.confirm": "سڕینەوە & دووبارە ڕەشکردنەوە",
  "confirmations.redraft.message": "دڵنیای دەتەوێت ئەم پۆستە بسڕیتەوە و دووبارە دایبڕێژیتەوە؟ فەڤۆریت و بووستەکان لەدەست دەچن، وەڵامەکانی پۆستە ئەسڵیەکەش هەتیو دەبن.",
  "confirmations.unfollow.confirm": "بەدوادانەچو",
  "conversation.delete": "سڕینەوەی گفتوگۆ",
  "conversation.mark_as_read": "نیشانەکردن وەک خوێندراوە",
  "conversation.open": "نیشاندان گفتوگۆ",
  "conversation.with": "لەگەڵ{names}",
  "copy_icon_button.copied": "کۆپی کراوە بۆ کلیپبۆرد",
  "copypaste.copied": "کۆپی کراوە",
  "copypaste.copy_to_clipboard": "کۆپی کراوە بۆ کلیپبۆرد",
  "directory.federated": "لە ڕاژەکانی ناسراو",
  "directory.local": "تەنها لە {domain}",
  "directory.new_arrivals": "تازە گەیشتنەکان",
  "directory.recently_active": "بەم دواییانە چالاکە",
  "disabled_account_banner.account_settings": "ڕێکخستنەکانی هەژمارە",
  "disabled_account_banner.text": "ئەکاونتەکەت {disabledAccount} لە ئێستادا لەکارخراوە.",
  "dismissable_banner.community_timeline": "ئەمانە دوایین پۆستی گشتی ئەو کەسانەن کە ئەکاونتەکانیان لەلایەن {domain}ەوە هۆست کراوە.",
  "dismissable_banner.dismiss": "بەلاوە نان",
  "embed.instructions": "ئەم توتە بنچین بکە لەسەر وێب سایتەکەت بە کۆپیکردنی کۆدەکەی خوارەوە.",
  "embed.preview": "ئەمە ئەو شتەیە کە لە شێوەی خۆی دەچێت:",
  "emoji_button.activity": "چالاکی",
  "emoji_button.clear": "ڕوون",
  "emoji_button.custom": "ئاسایی",
  "emoji_button.flags": "ئاڵاکان",
  "emoji_button.food": "خواردن& خواردنەوە",
  "emoji_button.label": "ئیمۆجی بکەنێو",
  "emoji_button.nature": "سروشت",
  "emoji_button.not_found": "بێ ئیمۆجی! (╯°□°)╯( ┻━┻",
  "emoji_button.objects": "ئامانجەکان",
  "emoji_button.people": "خەڵک",
  "emoji_button.recent": "زۆرجار بەکارهێنراوە",
  "emoji_button.search": "گەڕان...",
  "emoji_button.search_results": "ئەنجامەکانی گەڕان",
  "emoji_button.symbols": "هێماکان",
  "emoji_button.travel": "گەشت & شوێنەکان",
  "empty_column.account_suspended": "هەژمار ڕاگیرا",
  "empty_column.account_timeline": "لێرە هیچ نووسراوە نییە!",
  "empty_column.account_unavailable": "پرۆفایل بەردەست نیە",
  "empty_column.blocks": "تۆ هێشتا هیچ بەکارهێنەرێکت بلۆک نەکردووە.",
  "empty_column.bookmarked_statuses": "تۆ هێشتا هیچ توتێکی دیاریکراوت نیە کاتێک نیشانەیەک نیشان دەکەیت، لێرە دەرئەکەویت.",
  "empty_column.community": "هێڵی کاتی ناوخۆیی بەتاڵە. شتێک بە ئاشکرا بنووسە بۆ ئەوەی تۆپەکە بسووڕێت!",
  "empty_column.direct": "تا ئێستا هیچ نامەیەکی ڕاستەوخۆت نییە. کاتێک یەکێکیان دەنێری یان وەریدەگریت، لێرە دەردەکەوێت.",
  "empty_column.domain_blocks": "هێشتا هیچ دۆمەینێکی بلۆک کراو نییە.",
  "empty_column.explore_statuses": "لە ئێستادا هیچ شتێک ترێند نییە. دواتر سەیری بکە!",
  "empty_column.follow_requests": "تۆ هێشتا هیچ داواکارییەکی بەدواداچووت نیە. کاتێک یەکێکت بۆ هات، لێرە دەرئەکەویت.",
  "empty_column.followed_tags": "تۆ هێشتا شوێن هیچ هاشتاگێک نەکەوتوویت. کاتێک کردت، ئەوان لێرە دەردەکەون.",
  "empty_column.hashtag": "هێشتا هیچ شتێک لەم هاشتاگەدا نییە.",
  "empty_column.home": "تایم لاینی ماڵەوەت بەتاڵە! سەردانی {public} بکە یان گەڕان بەکاربێنە بۆ دەستپێکردن و بینینی بەکارهێنەرانی تر.",
  "empty_column.list": "هێشتا هیچ شتێک لەم لیستەدا نییە. کاتێک ئەندامانی ئەم لیستە دەنگی نوێ بڵاودەکەن، لێرە دەردەکەون.",
  "empty_column.mutes": "تۆ هێشتا هیچ بەکارهێنەرێکت بێدەنگ نەکردووە.",
  "empty_column.notifications": "تۆ هێشتا هیچ ئاگانامێکت نیە. چالاکی لەگەڵ کەسانی دیکە بکە بۆ دەستپێکردنی گفتوگۆکە.",
  "empty_column.public": "لێرە هیچ نییە! شتێک بە ئاشکرا بنووسە(بەگشتی)، یان بە دەستی شوێن بەکارهێنەران بکەوە لە ڕاژەکانی ترەوە بۆ پڕکردنەوەی",
  "error.unexpected_crash.explanation": "بەهۆی بوونی کێشە لە کۆدەکەمان یان کێشەی گونجانی وێبگەڕەکە، ئەم لاپەڕەیە بە دروستی پیشان نادرێت.",
  "error.unexpected_crash.explanation_addons": "ئەم لاپەڕەیە ناتوانرێت بە دروستی پیشان بدرێت. ئەم هەڵەیە لەوانەیە بەهۆی ئامێری وەرگێڕانی خۆکار یان زیادکراوی وێبگەڕەوە بێت.",
  "error.unexpected_crash.next_steps": "هەوڵدە لاپەڕەکە تازە بکەوە. ئەگەر ئەمە یارمەتیدەر نەبوو، لەوانەیە هێشتا بتوانیت ماستۆدۆن بەکاربێنیت لە ڕێگەی وێبگەڕەکەیان کاربەرنامەی ڕەسەن.",
  "error.unexpected_crash.next_steps_addons": "هەوڵدە لەکاریان بخەیت و لاپەڕەکە تازە بکەوە. ئەگەر ئەمە یارمەتیدەر نەبوو، لەوانەیە هێشتا بتوانیت ماستۆدۆن بەکاربێنیت لە ڕێگەی وێبگەڕەکانی دیکە یان نەرمەکالاکانی ئەسڵی.",
  "errors.unexpected_crash.copy_stacktrace": "کۆپیکردنی ستێکتراسی بۆ کلیپ بۆرد",
  "errors.unexpected_crash.report_issue": "کێشەی گوزارشت",
  "explore.suggested_follows": "خەڵک",
  "explore.trending_links": "هەواڵەکان",
  "explore.trending_statuses": "بڵاوکراوەکان",
  "explore.trending_tags": "هاشتاگەکان",
  "filter_modal.added.context_mismatch_explanation": "ئەم پۆلە فلتەرە ئەو چوارچێوەیە ناگرێتەوە کە تۆ تێیدا دەستت بەم پۆستە کردووە. ئەگەر بتەوێت پۆستەکە لەم چوارچێوەیەشدا فلتەر بکرێت، دەبێت دەستکاری فلتەرەکە بکەیت.",
  "filter_modal.added.context_mismatch_title": "ناتەبایی دەقی نووسراو!",
  "filter_modal.added.expired_explanation": "ئەم پۆلە فلتەرە بەسەرچووە، پێویستە بەرواری بەسەرچوونی بگۆڕیت بۆ ئەوەی جێبەجێی بکات.",
  "filter_modal.added.expired_title": "فلتەری بەسەرچووە!",
  "filter_modal.added.review_and_configure": "بۆ پێداچوونەوە و ڕێکخستنی زیاتری ئەم پۆلە فلتەرە، بچۆ بۆ {settings_link}.",
  "filter_modal.added.review_and_configure_title": "ڕێکخستنەکانی پاڵاوتن",
  "filter_modal.added.settings_link": "پەڕەی ڕێکخستن",
  "filter_modal.added.short_explanation": "بڵاوکراوەکە زیادکرا بۆ ئەو پاڵاوتنانەی خوارەوە: {title}.",
  "filter_modal.added.title": "پاڵێو زیادکرا!",
  "filter_modal.select_filter.context_mismatch": "لەم چوارچێوەیەدا کارپێکراو نییە",
  "filter_modal.select_filter.expired": "بەسەرچووە",
  "filter_modal.select_filter.prompt_new": "پۆلێنی نوێ: {name}",
  "filter_modal.select_filter.search": "گەڕان یان دروستکردن",
  "filter_modal.select_filter.subtitle": "بەکارهێنانی پۆلێنی بەردەست یان دروستکردنی پۆلێنێکی نوێ",
  "filter_modal.select_filter.title": "ئەم بڵاوکراوەیە بپاڵێوە",
  "filter_modal.title.status": "بڵاوکراوەیەک بپاڵێوە",
  "firehose.all": "هەموو",
  "firehose.local": "لەسەر ئەم ڕاژەیە",
  "firehose.remote": "ڕاژەکانی دی",
  "follow_request.authorize": "ده‌سه‌ڵاتپێدراو",
  "follow_request.reject": "ڕەتکردنەوە",
  "follow_requests.unlocked_explanation": "هەرچەندە هەژمارەکەت داخراو نییە، ستافی {domain} وا بیریان کردەوە کە لەوانەیە بتانەوێت پێداچوونەوە بە داواکاریەکانی ئەم هەژمارەدا بکەن بە دەستی.",
  "follow_suggestions.curated_suggestion": "ستاف هەڵبژاردنی",
  "follow_suggestions.dismiss": "دوبارە پشانی مەدە",
  "follow_suggestions.view_all": "بینینی هەموو",
  "follow_suggestions.who_to_follow": "دواکەوتنی کێ",
  "followed_tags": "هاشتاگە شوێنکەوتووەکان",
  "footer.about": "دەربارە",
  "footer.directory": "ڕابەری پەڕەی ناساندن",
  "footer.get_app": "بەرنامەکە بەدەست بێنە",
  "footer.keyboard_shortcuts": "کورتەڕێکانی تەختەکلیک",
  "footer.privacy_policy": "سیاسەتی تایبەتمەندێتی",
  "footer.source_code": "پیشاندانی کۆدی سەرچاوە",
  "footer.status": "دۆخ",
  "generic.saved": "پاشکەوتکرا",
  "getting_started.heading": "دەست پێکردن",
  "hashtag.column_header.tag_mode.all": "و {additional}",
  "hashtag.column_header.tag_mode.any": "یا {additional}",
  "hashtag.column_header.tag_mode.none": "بەبێ {additional}",
  "hashtag.column_settings.select.no_options_message": "هیچ پێشنیارێک نەدۆزرایەوە",
  "hashtag.column_settings.select.placeholder": "هاشتاگی تێبنووسە…",
  "hashtag.column_settings.tag_mode.all": "هەموو ئەمانە",
  "hashtag.column_settings.tag_mode.any": "هەر کام لەمانە",
  "hashtag.column_settings.tag_mode.none": "هیچ کام لەمانە",
  "hashtag.column_settings.tag_toggle": "تاگی زیادە ی ئەم ستوونە لەخۆ بنووسە",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} participant} other {{counter} participants}}",
  "hashtag.follow": "شوێنکەوتنی هاشتاگ",
  "hashtag.unfollow": "شوێن نەکەوتنی هاشتاگ",
  "home.column_settings.show_reblogs": "پیشاندانی بەهێزکردن",
  "home.column_settings.show_replies": "وەڵامدانەوەکان پیشان بدە",
  "home.hide_announcements": "شاردنەوەی راگەیەنراوەکان",
  "home.show_announcements": "پیشاندانی راگەیەنراوەکان",
  "interaction_modal.on_another_server": "لەسەر ڕاژەیەکی جیا",
  "interaction_modal.on_this_server": "لەسەر ئەم ڕاژەیە",
  "intervals.full.days": "{number, plural, one {# ڕۆژ} other {# ڕۆژەک}}",
  "intervals.full.hours": "{number, plural, one {# کات} other {# کات}}",
  "intervals.full.minutes": "{number, plural, one {# خولەک} other {# خولەک}}",
  "keyboard_shortcuts.back": "بۆ گەڕانەوە",
  "keyboard_shortcuts.blocked": "بۆ کردنەوەی لیستی بەکارهێنەرە بلۆککراوەکان",
  "keyboard_shortcuts.boost": "بۆ بەهێزکردن",
  "keyboard_shortcuts.column": "بۆ ئەوەی تیشک بخاتە سەر توتێک لە یەکێک لە ستوونەکان",
  "keyboard_shortcuts.compose": "بۆ سەرنجدان بە نووسینی ناوچەی دەق",
  "keyboard_shortcuts.description": "وه‌سف",
  "keyboard_shortcuts.down": "بۆ چوونە خوارەوە لە لیستەکەدا",
  "keyboard_shortcuts.enter": "بۆ کردنەوەی توت",
  "keyboard_shortcuts.federated": "بۆ کردنەوەی نووسراوەکانی هەمووشوێن",
  "keyboard_shortcuts.heading": "قه‌دبڕەکانی تەختەکلیل",
  "keyboard_shortcuts.home": "بۆ کردنەوەی هێڵی کاتی ماڵەوە",
  "keyboard_shortcuts.hotkey": "هۆتکەی",
  "keyboard_shortcuts.legend": "بۆ نیشاندانی ئەم نیشانە",
  "keyboard_shortcuts.local": "بۆ کردنەوەی نووسراوەکانی خۆماڵی",
  "keyboard_shortcuts.mention": "نۆ ناوبردن لە نووسەر",
  "keyboard_shortcuts.muted": "بۆ کردنەوەی پێرستی بەکارهێنەرانی بێدەنگ",
  "keyboard_shortcuts.my_profile": "بۆ کردنەوەی پرۆفایڵ",
  "keyboard_shortcuts.notifications": "بۆ کردنەوەی ستوونی ئاگانامەکان",
  "keyboard_shortcuts.open_media": "بۆ کردنەوەی میدیا",
  "keyboard_shortcuts.pinned": "بۆ کردنەوەی لیستی توتەکانی چەسپێنراو",
  "keyboard_shortcuts.profile": "بۆ کردنەوەی پرۆفایڵی نووسەر",
  "keyboard_shortcuts.reply": "بۆ وەڵامدانەوە",
  "keyboard_shortcuts.requests": "بۆ کردنەوەی لیستی داواکاریەکانی بەدوادا",
  "keyboard_shortcuts.search": "بۆ جەختکردن لەسەر گەڕان",
  "keyboard_shortcuts.spoilers": "بۆ پیشاندان/شاردنەوەی خانەی CW",
  "keyboard_shortcuts.start": "بۆ کردنەوەی ستوونی \"دەست پێبکە\"",
  "keyboard_shortcuts.toggle_hidden": "بۆ پیشاندان/شاردنەوەی دەق لە پشت CW",
  "keyboard_shortcuts.toggle_sensitivity": "بۆ پیشاندان/شاردنەوەی میدیا",
  "keyboard_shortcuts.toot": "بۆ دەست کردن بە براندێکی تازە",
  "keyboard_shortcuts.unfocus": "بۆ دروستکردنی ناوچەی دەق/گەڕان",
  "keyboard_shortcuts.up": "بۆ ئەوەی لە لیستەکەدا بڕۆیت",
  "lightbox.close": "دابخە",
  "lightbox.next": "داهاتوو",
  "lightbox.previous": "پێشوو",
  "limited_account_hint.action": "بەهەر حاڵ پڕۆفایلی پیشان بدە",
  "limited_account_hint.title": "ئەم پرۆفایلە لەلایەن بەڕێوەبەرانی {domain} شاراوەتەوە.",
  "lists.delete": "سڕینەوەی لیست",
  "lists.edit": "دەستکاری لیست",
  "lists.replies_policy.followed": "هەر بەکارهێنەرێکی بەدواکەوتوو",
  "lists.replies_policy.list": "ئەندامانی لیستەکە",
  "lists.replies_policy.none": "هیچکەس",
  "load_pending": "{count, plural, one {# بەڕگەی نوێ} other {# بەڕگەی نوێ}}",
  "moved_to_account_banner.text": "ئەکاونتەکەت {disabledAccount} لە ئێستادا لەکارخراوە چونکە تۆ چوویتە {movedToAccount}.",
  "navigation_bar.about": "دەربارە",
  "navigation_bar.blocks": "بەکارهێنەرە بلۆککراوەکان",
  "navigation_bar.bookmarks": "نیشانکراوەکان",
  "navigation_bar.direct": "ئاماژەی تایبەت",
  "navigation_bar.domain_blocks": "دۆمەینە بلۆک کراوەکان",
  "navigation_bar.filters": "وشە کپەکان",
  "navigation_bar.follow_requests": "بەدواداچوی داواکاریەکان بکە",
  "navigation_bar.followed_tags": "هاشتاگی بەدوادا هات",
  "navigation_bar.follows_and_followers": "شوێنکەوتوو و شوێنکەوتوان",
  "navigation_bar.lists": "لیستەکان",
  "navigation_bar.logout": "دەرچوون",
  "navigation_bar.mutes": "کپکردنی بەکارهێنەران",
  "navigation_bar.preferences": "پەسەندەکان",
  "navigation_bar.search": "گەڕان",
  "not_signed_in_indicator.not_signed_in": "پێویستە بچیتە ژوورەوە بۆ دەستگەیشتن بەم سەرچاوەیە.",
  "notification.admin.report": "{name} ڕاپۆرت کراوە {target}",
  "notification.admin.sign_up": "{name} تۆمارکرا",
  "notification.follow": "{name} دوای تۆ کەوت",
  "notification.follow_request": "{name} داوای کردووە کە شوێنت بکەوێت",
  "notification.own_poll": "ڕاپرسیەکەت کۆتایی هات",
  "notification.reblog": "{name} نووسراوەکەتی دووبارە توتاند",
  "notification.status": "{name} تازە بڵاوکرایەوە",
  "notification.update": "{name} پۆستێکی دەستکاریکرد",
  "notifications.clear": "ئاگانامەکان بسڕیەوە",
  "notifications.clear_confirmation": "ئایا دڵنیایت لەوەی دەتەوێت بە هەمیشەیی هەموو ئاگانامەکانت بسڕیتەوە?",
  "notifications.column_settings.admin.report": "ڕاپۆرتە نوێیەکان:",
  "notifications.column_settings.admin.sign_up": "چوونەژوورەوەی نوێ:",
  "notifications.column_settings.alert": "ئاگانامەکانی پیشانگەرر ڕومێزی",
  "notifications.column_settings.follow": "شوێنکەوتوانی نوێ:",
  "notifications.column_settings.follow_request": "شوینکەوتنی داواکاری نوێ:",
  "notifications.column_settings.mention": "ئاماژەکان:",
  "notifications.column_settings.poll": "ئەنجامەکانی ڕاپرسی:",
  "notifications.column_settings.push": "ئاگانامەکان پاڵ بنێ",
  "notifications.column_settings.reblog": "دووبارەتوتەکان:",
  "notifications.column_settings.show": "لە ستووندا پیشان بدە",
  "notifications.column_settings.sound": "لێدانی دەنگ",
  "notifications.column_settings.status": "توتەکانی نوێ:",
  "notifications.column_settings.unread_notifications.category": "ئاگاداریی نەبینراو",
  "notifications.column_settings.unread_notifications.highlight": "تیشک بخە سەر ئاگاداری نەخوێنراو",
  "notifications.column_settings.update": "دەستکاری:",
  "notifications.filter.all": "هەموو",
  "notifications.filter.boosts": "دووبارەتوتەکان",
  "notifications.filter.follows": "بەدواداچوون",
  "notifications.filter.mentions": "ئاماژەکان",
  "notifications.filter.polls": "ئەنجامەکانی ڕاپرسی",
  "notifications.filter.statuses": "نوێکردنەوەکان ئەو کەسانەی کە پەیڕەوی دەکەیت",
  "notifications.grant_permission": "مۆڵەت بدە.",
  "notifications.group": "{count} ئاگانامە",
  "notifications.mark_as_read": "هەموو ئاگانامەکان وەک خوێندراوەتەوە نیشان بکە",
  "notifications.permission_denied": "ناتوانرێت ئاگانامەکانی دێسکتۆپ چالاک بکرێت وەک ڕێپێدان ڕەتکرایەوە.",
  "notifications.permission_denied_alert": "ناتوانرێت ئاگانامەکانی دێسکتۆپ چالاک بکرێت، چونکە پێشتر مۆڵەتی وێبگەڕ ڕەتکرایەوە",
  "notifications.permission_required": "ئاگادارکردنەوەکانی سەر مێز بەردەست نین چونکە مۆڵەتی پێویست نەدراوە.",
  "notifications_permission_banner.enable": "چالاککردنی ئاگانامەکانی دێسکتۆپ",
  "notifications_permission_banner.how_to_control": "بۆ وەرگرتنی ئاگانامەکان کاتێک ماستۆدۆن نەکراوەیە، ئاگانامەکانی دێسکتۆپ چالاک بکە. دەتوانیت بە وردی کۆنترۆڵی جۆری کارلێکەکان بکەیت کە ئاگانامەکانی دێسکتۆپ دروست دەکەن لە ڕێگەی دوگمەی {icon} لەسەرەوە کاتێک چالاک دەکرێن.",
  "notifications_permission_banner.title": "هەرگیز شتێک لە دەست مەدە",
  "picture_in_picture.restore": "بیگەڕێنەوە",
  "poll.closed": "دابخە",
  "poll.refresh": "نوێکردنەوە",
  "poll.total_people": "{count, plural, one {# خەڵک} other {# خەڵک}}",
  "poll.total_votes": "{count, plural, one {# دەنگ} other {# دەنگ}}\n",
  "poll.vote": "دەنگ",
  "poll.voted": "تۆ دەنگت بەو وەڵامە دا",
  "poll.votes": "{votes, plural, one {# دەنگ} other {# دەنگ}}",
  "poll_button.add_poll": "ڕاپرسییەک زیاد بکە",
  "poll_button.remove_poll": "ده‌نگدان بسڕه‌وه‌‌",
  "privacy.change": "ڕێکخستنی تایبەتمەندی توت",
  "privacy.public.short": "گشتی",
  "privacy_policy.last_updated": "دوایین نوێکردنەوە {date}",
  "privacy_policy.title": "سیاسەتی تایبەتێتی",
  "refresh": "نوێکردنەوە",
  "relative_time.days": "{number}ڕۆژ",
  "relative_time.full.days": "{number, plural, one {# ڕۆژ} other {# ڕۆژ}} ماوە",
  "relative_time.full.hours": "{number, plural, one {# کاتژمێر} other {# کاتژمێر}} ماوە",
  "relative_time.full.just_now": "ئێستا",
  "relative_time.full.minutes": "{number, plural, one {# خولەک} other {# خولەک}} ماوە",
  "relative_time.full.seconds": "{number, plural, one {# چرکە} other {# چرکە}} ماوە",
  "relative_time.hours": "{number}کات",
  "relative_time.just_now": "ئێستا",
  "relative_time.minutes": "{number}کات",
  "relative_time.seconds": "{number}کات",
  "relative_time.today": "ئیمڕۆ",
  "reply_indicator.cancel": "هەڵوەشاندنەوه",
  "report.block": "بلۆک",
  "report.block_explanation": "تۆ پۆستەکانیان نابینیت. ئەوان ناتوانن بابەتەکانتان ببینن یان شوێنتان بکەون. ئەوان دەتوانن بڵێن کە بەربەستکراون.",
  "report.categories.other": "هی تر",
  "report.categories.spam": "سپام",
  "report.categories.violation": "ناوەڕۆک یەک یان زیاتر لە یاساکانی سێرڤەر پێشێل دەکات",
  "report.category.subtitle": "باشترین هاوتا هەڵبژێرە",
  "report.category.title": "پێمان بڵێ بە {type} چی ڕوودەدات",
  "report.category.title_account": "پرۆفایل",
  "report.category.title_status": "پۆست",
  "report.close": "تەواو",
  "report.comment.title": "ئایا هیچ شتێکی تر هەیە کە پێت وایە ئێمە دەبێت بزانین?",
  "report.forward": "ناردن بۆ {target}",
  "report.forward_hint": "هەژمارەکە لە ڕاژەیەکی ترە. ڕونووسێکی نەناسراو بنێرە بۆ گوزارشت لەوێ?",
  "report.mute": "بێدەنگ",
  "report.mute_explanation": "تۆ پۆستەکانیان نابینیت. ئەوان هێشتا دەتوانن شوێنتان بکەون و پۆستەکانتان ببینن و نازانن کە ئەوان بێ دەنگن.",
  "report.next": "دواتر",
  "report.placeholder": "سەرنجەکانی زیاتر",
  "report.reasons.dislike": "حەزم لێی نییە",
  "report.reasons.dislike_description": "ئەوە شتێک نیە کە دەتەوێت بیبینیت",
  "report.reasons.other": "شتێکی ترە",
  "report.reasons.other_description": "کێشەکە ناگونجێت بۆ هاوپۆلەکانی تر",
  "report.reasons.spam": "ئەوە سپامە",
  "report.reasons.spam_description": "لینکە خراپەکان، بەشداری ساختە، یان وەڵامدانەوەی دووبارە",
  "report.reasons.violation": "یاساکانی سێرڤەر پێشێل دەکات",
  "report.reasons.violation_description": "ئاگاداری ئەوەن کە یاسا تایبەتەکان دەشکێنێت",
  "report.rules.subtitle": "هەموو ئەوانەی کە کاریان پێدەکرێت هەڵبژێرە",
  "report.rules.title": "کام یاسا پێشێل دەکرێت؟",
  "report.statuses.subtitle": "هەموو ئەوانەی کە کاریان پێدەکرێت هەڵبژێرە",
  "report.statuses.title": "ئایا هیچ پۆستێک هەیە کە پشتگیری ئەم ڕاپۆرتە بکات؟",
  "report.submit": "ناردن",
  "report.target": "گوزارشتکردنی{target}",
  "report.thanks.take_action": "لێرەدا بژاردەکانت بۆ کۆنترۆڵکردنی ئەو شتانە دەخەینەڕوو کە لە ماستۆدۆن دەیبینیت:",
  "report.thanks.take_action_actionable": "لە کاتێکدا ئێمە پێداچوونەوە بەم بابەتە دەکەین، دەتوانیت ڕێوشوێن بگریتەبەر دژی @{name}:",
  "report.thanks.title": "ناتەوێت ئەمە ببینیت؟",
  "report.thanks.title_actionable": "سوپاس بۆ ڕاپۆرتکردن، ئێمە سەیری ئەم بابەتە دەکەین.",
  "report.unfollow": "بەدوادانەچوو@{name}",
  "report.unfollow_explanation": "تۆ شوێنکەوتووی ئەم هەژماررەی دەکەیت. بۆ ئەوەی چیتر نووسراوەکانیان لە هۆم فیدی خۆت نەبینی، بەدوایان مەچۆ.",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "report_notification.categories.other": "هی تر",
  "report_notification.categories.spam": "سپام",
  "report_notification.categories.violation": "پێشێلکردنی یاسا",
  "report_notification.open": "ڕاپۆرتەکان بکەوە",
  "search.no_recent_searches": "گەڕانەکانی ئەم دواییە",
  "search.placeholder": "گەڕان",
  "search.quick_action.account_search": "پڕۆفایلی هاوتا لەگەڵ {x}",
  "search.quick_action.go_to_account": "بڕۆ بۆ پڕۆفایلی{x}",
  "search.quick_action.go_to_hashtag": "بڕۆ بۆ هاشتاگی {x}",
  "search.quick_action.open_url": "بەستەرەکان لەناو ماستۆدۆن بکەوە",
  "search.quick_action.status_search": "پڕۆفایلی هاوتا لەگەڵ {x}",
  "search.search_or_paste": "گەڕان یان لێدانی URL",
  "search_popout.quick_actions": "کرداری خێرا",
  "search_popout.recent": "گەڕانەکانی ئەم دواییە",
  "search_results.accounts": "پرۆفایلەکان",
  "search_results.all": "هەموو",
  "search_results.hashtags": "هەشتاگ",
  "search_results.statuses": "توتەکان",
  "server_banner.about_active_users": "ئەو کەسانەی لە ماوەی ٣٠ ڕۆژی ڕابردوودا ئەم سێرڤەرە بەکاردەهێنن (بەکارهێنەرانی چالاک مانگانە)",
  "server_banner.active_users": "بەکارهێنەرانی چالاک",
  "server_banner.administered_by": "بەڕێوەبردن لەلایەن:",
  "server_banner.server_stats": "دۆخی ڕاژەکار:",
  "sign_in_banner.create_account": "هەژمار دروستبکە",
  "sign_in_banner.sign_in": "بچۆ ژوورەوە",
  "status.admin_account": "کردنەوەی میانڕەوی بەڕێوەبەر بۆ @{name}",
  "status.admin_domain": "ڕووکاری مامناوەندی بکەرەوە بۆ {domain}",
  "status.admin_status": "ئەم توتە بکەوە لە ناو ڕووکاری بەڕیوەبەر",
  "status.block": "@{name} ئاستەنگ بکە",
  "status.bookmark": "نیشانه",
  "status.cancel_reblog_private": "بێبەهێزکردن",
  "status.cannot_reblog": "ئەم بابەتە ناتوانرێت بەرزبکرێتەوە",
  "status.copy": "ڕوونووسی بەستەر بۆ توت",
  "status.delete": "سڕینەوە",
  "status.detailed_status": "ڕوانگەی گفتوگۆ بە وردەکاری",
  "status.direct": "بە شێوەیەکی تایبەت باسی @{name} بکە",
  "status.direct_indicator": "ئاماژەی تایبەت",
  "status.edit": "دەستکاری",
  "status.edited_x_times": "دەستکاریکراوە {count, plural, one {{count} کات} other {{count} کات}}",
  "status.filter": "ئەم پۆستە فلتەر بکە",
  "status.history.created": "{name} دروستکراوە لە{date}",
  "status.history.edited": "{name} دروستکاریکراوە لە{date}",
  "status.load_more": "زیاتر بار بکە",
  "status.media_hidden": "میدیای شاراوە",
  "status.mention": "ناوبنێ @{name}",
  "status.more": "زیاتر",
  "status.mute": "@{name} بێدەنگ بکە",
  "status.mute_conversation": "بێدەنگی بکە",
  "status.open": "ئەم توتە فراوان بکە",
  "status.pin": "لکاندن لەسەر پرۆفایل",
  "status.read_more": "زیاتر بخوێنەوە",
  "status.reblog": "بەهێزکردن",
  "status.reblogged_by": "{name} توتی کردەوە",
  "status.reblogs.empty": "کەس ئەم توتەی دووبارە نەتوتاندوە ،کاتێک کەسێک وا بکات، لێرە دەرئەکەون.",
  "status.redraft": "سڕینەوەی و دووبارە ڕەشنووس",
  "status.remove_bookmark": "لابردنی نیشانه",
  "status.replied_to": "لە وەڵامدا بۆ {name}",
  "status.reply": "وەڵام",
  "status.replyAll": "بە نووسراوە وەڵام بدەوە",
  "status.report": "گوزارشت @{name}",
  "status.sensitive_warning": "ناوەڕۆکی هەستیار",
  "status.share": "هاوبەشی بکە",
  "status.show_less_all": "هەمووی بچووک بکەوە",
  "status.show_more_all": "زیاتر نیشان بدە بۆ هەمووی",
  "status.show_original": "پیشاندانی شێوه‌ی ڕاسته‌قینه‌",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.translate": "وەریبگێرە",
  "status.translated_from_with": "لە {lang} وەرگێڕدراوە بە بەکارهێنانی {provider}",
  "status.unmute_conversation": "گفتوگۆی بێدەنگ",
  "status.unpin": "لە سەرەوە لایبە",
  "subscribed_languages.lead": "تەنها پۆستەکان بە زمانە هەڵبژێردراوەکان لە ماڵەکەتدا دەردەکەون و هێڵەکانی کاتی لیستەکەت دوای گۆڕانکارییەکە. هیچیان هەڵبژێرە بۆ وەرگرتنی پۆست بە هەموو زمانەکان.",
  "subscribed_languages.save": "پاشکەوتی گۆڕانکاریەکان",
  "subscribed_languages.target": "گۆڕینی زمانە بەشداربووەکان بۆ {target}",
  "tabs_bar.home": "سەرەتا",
  "tabs_bar.notifications": "ئاگادارییەکان",
  "time_remaining.days": "{number, plural, one {# ڕۆژ} other {# ڕۆژ}} ماوە",
  "time_remaining.hours": "{number, plural, one {# کاتژمێر} other {# کاتژمێر}} ماوە",
  "time_remaining.minutes": "{number, plural, one {# خولەک} other {# خولەک}} ماوە",
  "time_remaining.moments": "کاتی ماوە",
  "time_remaining.seconds": "{number, plural, one {# چرکە} other {# چرکە}} ماوە",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {{days} days}}",
  "trends.trending_now": "ڕۆژەڤ",
  "ui.beforeunload": "ڕەشنووسەکەت لەدەست دەچێت ئەگەر ماستۆدۆن جێ بهێڵیت.",
  "units.short.billion": "{count} ملیار",
  "units.short.million": "{count} ملیۆن",
  "units.short.thousand": "{count} هەزار",
  "upload_area.title": "فایلەکانت ڕابکێشە ئێرە بۆ بەرزکردنەوەیان",
  "upload_button.label": "وێنە، ڤیدیۆ یان پەیامی دەنگی زیاد بکە",
  "upload_error.limit": "سنووری بەرزکردنەوەت بەزاندووە.",
  "upload_error.poll": "فایل و ڕاپرسی پێکەوە ڕێپێنەدراون.",
  "upload_form.edit": "دەستکاری",
  "upload_progress.label": "بار دەکرێت...",
  "upload_progress.processing": "جێبەجێکردن...",
  "video.close": "داخستنی ڤیدیۆ",
  "video.download": "داگرتنی فایل",
  "video.exit_fullscreen": "دەرچوون لە پڕ شاشە",
  "video.expand": "ڤیدیۆفراوان بکە",
  "video.fullscreen": "پڕپیشانگەر",
  "video.hide": "شاردنەوەی ڤیدیۆ",
  "video.pause": "وەستان",
  "video.play": "لێی بدە"
}
